import { hookstate } from "@hookstate/core";
import { I18n } from "aws-amplify";
import moment from "moment";
import { getCoffrets, getInstallations } from "../../service/ScrbService";
import classNames from "classnames";

export const currentInstallation = hookstate({});
export const loadCurrentInstallation = async (structureId, installationId, callBack) => {
    await getInstallations(structureId, installationId).then((res) => {
        currentInstallation.set(res[0]);
        if (callBack) {
            callBack();
        }
    });
}
export const allInstallations = hookstate([]);
export const loadInstallations = async (structureId) => {
    await getInstallations(structureId, null, true).then((res) => {
        allInstallations.set(res);
    });
}
export const tourneeInstallations = hookstate([]);
export const loadTourneeInstallations = async (structureId) => {
    await getInstallations(structureId, null, false).then((res) => {
        tourneeInstallations.set(res);
    });
}
export const allTournees = hookstate([]);
export const currentTournee = hookstate({});
export const allCoffrets = hookstate([]);
export const loadCoffrets = async (structureId) => {
    await getCoffrets(structureId).then((res) => {
        allCoffrets.set(res);
    });
}
export const currentCoffret = hookstate({});
export const scrbData = hookstate({});
export const allCountries = hookstate([]);

export const parseDate = (dateToParse) => {
    if (!dateToParse) {
        return "";
    }
    return moment(dateToParse).format("DD/MM/YYYY");
};

export const parseTime = (timeToParse) => {
    return moment.utc(timeToParse).format("HH:mm");
};

export const getEasyListLabel = (list, id) => {
    return list.find(item => item.id === id)?.label || "";
};

export const translateList = (lst) => {
    return lst.map(e => { return { id: e.id, label: I18n.get(e.label), icon: e.icon, style: e.style } });
};

export const sortOptions = (options) => {
    let opt = JSON.parse(JSON.stringify(options));
    return opt.sort((a, b) => a.label.localeCompare(b.label));
};

export function getChaudList(genreInst) {
    return scrbData.get().typeChaudiereList.filter((t) => t.genreInst === genreInst)
};

export function getInstallationList(genreInst) {
    return scrbData.get().typeInstallationList.filter((t) => t.genreInst.includes(genreInst))
};

export const statutCoffretTemplate = (status) => {
    const css = status === 1 ? "coffret-status-actif" : "coffret-status-out";
    return (
        <span className={classNames("coffret-status", css)}>
            {status === 1 ? I18n.get("actif") : I18n.get("horsService")}
        </span>
    );
}

export const agreeTemplate = (agree, statut, label) => {
    const agreeLabel = agree ?
        <div className="tournee-status tournee-status-validee">{label}</div> :
        <div className="tournee-status tournee-status-attente">{label}</div>;
    const statutLabel = statut === 1 ? agreeLabel : <div className="tournee-status coffret-status-out">{label}</div>;
    return statutLabel;
}

export const extractTournees = (installations) => {
    const tournees = {};
    const dateNow = moment(new Date()).add(-1, 'day').toDate();
    installations.forEach(installation => {
        if (installation.debutReception && installation.statut < 8 && installation.controleurId && moment(installation.debutReception).isAfter(dateNow)) {
            const date = installation.debutReception.split("T")[0];
            const key = `${date} ${installation.controleurId}`;
            if (!tournees[key]) {
                tournees[key] = {
                    date,
                    controleurId: installation.controleurId,
                    meetings: []
                };
            }
            const meeting = {
                structureId: installation.structureId,
                debutReception: installation.debutReception.substring(0, 16),
                deleted: false,
                nom: installation.nom,
                tel: installation.tel,
                owner: installation.nomOwner,
                telOwner: installation.telOwner,
                installationId: installation.id,
                referenceExterne: installation.referenceExterne,
                adresse: (installation.address.number || "") + " " + (installation.address.street || "") + " " + (installation.address.codePostal || "") + " " + (installation.address.localite || ""),
                localite: installation.address.localite,
                genreInstallationId: installation.genreInstallationId,
                recStatusId: installation.statut || 3
            };
            tournees[key].meetings.push(meeting);
        }
    });
    Object.values(tournees).forEach(tournee => {
        tournee.meetings.sort((a, b) => new Date(a.debutReception) - new Date(b.debutReception));
        tournee.validee = tournee.meetings.every(meeting => meeting.recStatusId === 5);
    });
    return Object.values(tournees).sort((a, b) =>
        new Date(a.date) - new Date(b.date)
    );
};

export const addMeetingFromInstallation = (installation) => {
    return {
        structureId: installation.structureId,
        debutReception: installation.debutReception,
        deleted: false,
        nom: installation.nom,
        tel: installation.tel,
        owner: installation.nomOwner,
        telOwner: installation.telOwner,
        installationId: installation.id,
        referenceExterne: installation.referenceExterne,
        adresse: (installation.address.number || "") + " " + (installation.address.street || "") + " " + (installation.address.codePostal || "") + " " + (installation.address.localite || ""),
        genreInstallationId: installation.genreInstallationId,
        recStatusId: 3
    }
}

export const calculateTourneeDuration = (meetings) => {
    const duree = meetings.reduce((acc, meeting) => acc + scrbData.get().genreInstList.find(g => g.id === meeting.genreInstallationId).duree, 0);
    return duree;
}

export const calculateDurationBeforeAddMeeting = (meetings, newMeeting) => {
    let duree = calculateTourneeDuration(meetings);
    duree = duree + scrbData.get().genreInstList.find(g => g.id === newMeeting.genreInstallationId).duree;
    return duree;
}

export const validateTel = (tel) => {
    const regex = /^(\+\d{1,3}\s?)?(\d{1,4}[-.\s]?){1,4}\d{1,4}$/;
    return regex.test(tel);
};

export const validateYear = (year) => {
    const yearInt = moment(year, "YYYY").year();
    const currentYear = new Date().getFullYear();
    return yearInt >= 1900 && yearInt <= currentYear + 1;
};

export const scrollToTop = () => {
    window.scrollTo(0, 0);
};

export const setCursorProgress = () => {
    document.body.style.cursor = 'progress';
}

export const setCursorDefault = () => {
    document.body.style.cursor = 'default';
}

export const toolToFixed = (value) => {
    if (value === null || value === undefined) {
        return "";
    }
    return value.toFixed(2);
}